export const isColor = (color: string) =>
  /^#(([a-f0-9]){3}|([a-f0-9]){6}|([a-f0-9]){8})$|(rgba?\()|(hsla?\()/i.test(color);
